import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useWishlistStore } from "@/store/wishlistStore";
import { useNavigate } from "react-router-dom";
import { Heart, LogIn, Bookmark } from "lucide-react";
import { alertToast } from "@/contexts/AlertToastContext";

export const WishlistLoginPrompt = () => {
  const navigate = useNavigate();
  const { 
    showLoginPrompt, 
    pendingProduct, 
    setShowLoginPrompt, 
    setPendingProduct,
    addItemLocal 
  } = useWishlistStore();

  const handleLogin = () => {
    setShowLoginPrompt(false);
    navigate('/auth');
  };

  const handleSaveLocally = () => {
    if (pendingProduct) {
      addItemLocal(pendingProduct);
      alertToast.success('המוצר נשמר למועדפים!');
    }
    setShowLoginPrompt(false);
    setPendingProduct(null);
  };

  const handleClose = () => {
    setShowLoginPrompt(false);
    setPendingProduct(null);
  };

  return (
    <Dialog open={showLoginPrompt} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md" dir="rtl">
        <DialogHeader className="text-right">
          <div className="flex justify-center mb-4">
            <div className="bg-primary/10 p-4 rounded-full">
              <Heart className="h-8 w-8 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">שמירת מוצר למועדפים</DialogTitle>
          <DialogDescription className="text-center text-base mt-2">
            איך תרצה לשמור את המוצר?
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 py-4">
          <Button 
            onClick={handleLogin}
            className="w-full h-12 text-base"
            variant="default"
          >
            <LogIn className="ml-2 h-5 w-5" />
            התחבר לחשבון
            <span className="text-xs mr-2 opacity-70">(מומלץ)</span>
          </Button>
          
          <Button 
            onClick={handleSaveLocally}
            variant="outline"
            className="w-full h-12 text-base"
          >
            <Bookmark className="ml-2 h-5 w-5" />
            שמור בלי התחברות
          </Button>
        </div>

        <DialogFooter className="text-center">
          <p className="text-xs text-muted-foreground w-full">
            שמירה עם התחברות מאפשרת גישה למועדפים מכל מכשיר
          </p>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
